var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    ['shortlist shortlist--white']: true,
    ['is-open']: _vm.isVisible,
  }},[_c('div',{staticClass:"shortlist__content pbn"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }